import { useMutation } from '@tanstack/react-query'

import { axiosAPI } from '@/api/new-api'

type ActivateUserRequest = {
  email: string
  hash: string
}

// NOTE: credentials go in the body, never the URL path, so they don't end up in proxy/access
// logs (EL-10743). Rate-limited by BE per email and per IP — expect 429 on repeated attempts.
export const activateUser = async (data: ActivateUserRequest) => {
  const response = await axiosAPI.post('/activation', data)
  return response.data
}

export const useActivateUser = () =>
  useMutation({
    mutationFn: activateUser,
  })
